import { render } from "./Nav.vue?vue&type=template&id=8094f970"
import script from "./Nav.vue?vue&type=script&lang=js"
export * from "./Nav.vue?vue&type=script&lang=js"

import "./Nav.vue?vue&type=style&index=0&id=8094f970&lang=css"
script.render = render

export default script